
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// import 'react-dropzone-component/styles/filepicker.css'
import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import HelpImage from "assets/images/HelpImage.png";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
// import dataTableData from "layouts/applications/data-tables/data/dataTableData";
import { Autocomplete, Icon, IconButton, Popover, TextField, Typography } from "@mui/material";
import { grades, subjects, Table } from "types";
import MDInput from "components/MDInput";
import { createCategory, deleteCategory, getMyCategories, updateCategory } from "services/category-services";
import { getUUIDFromKey } from "utils/helpers";
import Alert from "components/Alert";
import { useAppContext } from "context/app-context";

interface CardType {
  PK: string
  name: string
  subject: string
  grade: string
  isShared: boolean
}

function Categories(): JSX.Element {
  const [pk, setPk] = useState<string>('')
  const [subjectValue, setSubjectValue] = useState<string | null>(null);
  const [inputSubjectValue, setSubjectInputValue] = useState('');
  const [gradeValue, setGradeValue] = useState<string | null>(null);
  const [inputGradeValue, setGradeInputValue] = useState('');
  const [data, setData] = useState({} as Table)
  const [card, setCard] = useState({} as CardType)
  const [dataTableData, setDataTableData] = useState<null | Table>(null)
  const [name, setName] = useState<string>('')
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const popoverOpen = Boolean(anchorEl)

  useEffect(() => {
    (async () => {
      setDataTableData({
        columns: [
          { Header: "Redigér", accessor: "editLink", width: "10%" },
          { Header: "Slet", accessor: "removeLink", width: "10%" },
          { Header: "titel", accessor: "name", width: "60%" },
          { Header: "Klassetrin", accessor: "grade", width: "10%" },
          { Header: "Fag", accessor: "subject", width: "10%" }], rows: await getMyCategories()
      })
    })()
  }, [])


  useEffect(() => {
    if (dataTableData) {
      setData({
        ...dataTableData, rows: dataTableData.rows.map((dt) => ({
          ...dt,
          editLink: (
            <IconButton key={dt.title} onClick={() => setCard({ ...dt, name: dt.name, PK: dt.PK, grade: dt.grade, subject: dt.subject, isShared: dt.isShared as boolean })}><Icon fontSize="small">edit</Icon></IconButton>
          ),
          removeLink: (
            <IconButton key={dt.title} onClick={async () => await warningWithConfirmAndCancelMessage(dt.PK, dt.countSubCategories)}><Icon fontSize="small">delete</Icon></IconButton>
          )
        })
        )
      })
    }
  }, [dataTableData])


  useEffect(() => {
    if (Object.keys(card).length) {
      setPk(card.PK)
      setGradeValue(card.grade)
      setName(card.name)
      setSubjectValue(card.subject)
    }
  }, [card])

  const { handleMessage } = useAppContext()

  const handleCreateCategory = async () => {
    try {
      const PK = await createCategory({
        name, subject: subjectValue, grade: gradeValue
      })

      setDataTableData({
        ...dataTableData, rows: [...dataTableData.rows, { PK: `CATEGORY#${PK}`, name, subject: subjectValue, grade: gradeValue }]
      })
      handleMessage('Du har oprettet en kategori', 'success')
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }
  }

  const handleUpdateCategory = async () => {
    try {
      const udatedCategory = await updateCategory(getUUIDFromKey(pk), {
        name, subject: subjectValue, grade: gradeValue
      })

      dataTableData.rows.splice(dataTableData.rows.findIndex((dt: any) => dt.PK === pk), 1, udatedCategory)
      setDataTableData({
        ...dataTableData, rows: [...dataTableData.rows]
      })
      setPk('')
      handleMessage(`Du har opdateret kategorien ${name}`, 'success')
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }
  }

  const handleDeleteCategory = async (categoryId: string) => {
    try {
      await deleteCategory(getUUIDFromKey(categoryId))
      setDataTableData({
        ...dataTableData, rows: dataTableData.rows.filter(dt => dt.PK !== categoryId)
      })
      success()
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }

  }
  const [alert, setAlert] = useState(null)

  const hideAlert = () => {
    setAlert(null);
  };
  const success = (type = 'archive') => {
    setAlert(
      //@ts-ignore
      <Alert
        success
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Slettet!'
        confirmBtnText='Okay'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle='success'
        btnSize=''
      > Din kategori blev slettet...</Alert>
    );
  };
  const cancel = () => {
    setAlert(
      <Alert
        danger
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Aflyst'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnText='Okay'
        confirmBtnBsStyle='success'
        btnSize=''
      ></Alert>
    );
  };
  const warningWithConfirmAndCancelMessage = (id: string, countSubCategories: number) => {
    setAlert(
      //@ts-ignore
      <Alert
        warning
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Er du sikker?'
        onConfirm={async () => {
          await handleDeleteCategory(id);
        }}
        onCancel={() => cancel()}
        confirmBtnBsStyle='success'
        cancelBtnBsStyle='danger'
        confirmBtnText='Ja, slet!'
        cancelBtnText='Annullér'
        showCancel
        btnSize=''
      > {countSubCategories ?
        `Advarsel- denne kategori har ${countSubCategories} quizkategorier tilknyttet! Er du sikker på at du vil slette denne kategori?` : 'Er du sikker på at du vil slette denne kategori?'}
      </Alert>
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid spacing={3} justifyContent="center">
          {alert}
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={3} lineHeight={1} display='flex' alignItems='center' gap={1}>
                <MDTypography variant="h5" fontWeight="medium">
                  Mine hovedkategori
                </MDTypography>
                <Typography
                  aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
                  aria-haspopup="true"
                  onMouseEnter={handlePopoverOpen}
                  onMouseLeave={handlePopoverClose}
                  style={{
                    lineHeight: '1rem',
                    cursor: 'pointer',
                  }}>
                  <Icon>help</Icon>
                </Typography>
                <Popover
                  id="mouse-over-popover"
                  style={{ pointerEvents: 'none' }}
                  PaperProps={{sx: { backgroundColor: '#fff'}}}
                  disableAutoFocus
                  disableEnforceFocus
                  open={popoverOpen}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  onClose={handlePopoverClose}>

                    <img src={HelpImage} width={380} alt="quizCategory" />
                  {/* <Typography style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <p>Før du opretter hovedkategorier; så tjek om de ikke allerede er oprettet. <br />
                      Hovedkategorier skal oprettes FØR quizkategorier.
                    </p>
                  </Typography> */}
                </Popover>
              </MDBox>
              <Grid container>

                <Grid style={{ overflowX: 'auto' }} item sm={12} lg={8} >

                  {Object.keys(data).length ? <DataTable table={data} canSearch /> : null}

                </Grid>
                <Grid item sm={12} lg={4} >

                  <MDBox
                    justifyContent='space-between'
                    alignItems='center'
                    display='flex'
                    flexDirection='column'>
                    <MDBox mt={1} px={2} width={"100%"}>
                      <MDBox mt={1} px={2} max-width={500}>
                        <Card>
                          <MDBox mt={1} mx={1}>
                            <Autocomplete
                              noOptionsText="Ingen muligheder endnu"
                              value={gradeValue}
                              onChange={(event: any, newValue: string | null) => {
                                setGradeValue(newValue);
                              }}
                              inputValue={inputGradeValue}
                              onInputChange={(event, newInputValue) => {
                                setGradeInputValue(newInputValue);
                              }}
                              id="controllable-states-grades"
                              options={grades}
                              renderInput={(params) => <TextField {...params} label="Klassetrin" />}
                            />
                          </MDBox>
                          <MDBox mt={1} mx={1}>
                            <Autocomplete
                              noOptionsText="Ingen muligheder endnu"
                              value={subjectValue}
                              onChange={(event: any, newValue: string | null) => {
                                setSubjectValue(newValue);
                              }}
                              inputValue={inputSubjectValue}
                              onInputChange={(event, newInputValue) => {
                                setSubjectInputValue(newInputValue);
                              }}
                              id="controllable-states-subjects"
                              options={subjects}
                              renderInput={(params) => <TextField {...params} label="Fag/Emner" />}
                            />
                            
                          </MDBox>
                          <MDBox mt={1} mx={1}>
                            <MDInput
                              fullWidth
                              label="Kategori-navn"
                              value={name}
                              onChange={(e: any) => setName(e.target.value)}
                            />
                          </MDBox>
                          <MDBox p={3} px={10} mx='auto'>

                            {
                              !!pk ?
                                <MDButton onClick={handleUpdateCategory} color='info'>Gem dine rettelser</MDButton>
                                :
                                <MDButton onClick={handleCreateCategory} color='info'>Opret kategori</MDButton>
                            }

                          </MDBox>
                        </Card>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox >
    </DashboardLayout >
  );
}

export default Categories;
